import axios from 'axios'

const baseURL = import.meta.env.VITE_API_BASE_URL || `${window.location.origin}/api/v1`

const axiosInstance = axios.create({
  baseURL,
  withCredentials: true,
})

export const defineAuth = ({ token }) => {
  if (token) {
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`
  } else {
    delete axiosInstance.defaults.headers.common['Authorization']
  }
}

export default axiosInstance
